module.exports = __webpack_public_path__ + "img/firstPage.cf672d8d.jpeg";